import React from "react";
import PropTypes from "prop-types";

function Label(Props) {
  const { children, labelText, className, show } = Props;
  return (
    <label
      className={className}
    //   dangerouslySetInnerHTML={{ __html: labelText }}
    >
      {children || labelText}
    </label>
  );
}

Label.propTypes = {
  labelText: PropTypes.string,
  className: PropTypes.string,
  show: PropTypes.bool,
  children: PropTypes.node,
};

Label.defaultProps = {
  labelText: "Label",
  className: "",
  show: true,
  children: undefined,
};

export default Label;
